import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box, Typography, useTheme } from '@mui/material'
import type { FormattedAgentActivity } from '../utils'
import { diffStatsAddedSx, diffStatsRemovedSx } from '../../shared/styles'

interface ActivityStatsProps {
  readonly activity: FormattedAgentActivity
}

export const ActivityStats: FC<ActivityStatsProps> = ({ activity }) => {
  if (!activity.suffix) {
    return null
  }

  return <DiffStats suffix={activity.suffix} />
}

interface DiffStatsProps {
  readonly suffix: string
}

const DiffStats: FC<DiffStatsProps> = ({ suffix }) => {
  const theme = useTheme()
  const parts = suffix.split(' ').filter((part) => part.trim())

  return (
    <Box sx={statsContainerSx}>
      {parts.map((part, index) => {
        if (part.startsWith('+')) {
          return (
            <Typography
              key={`add-${part}`}
              component="span"
              sx={{
                ...diffStatsAddedSx(theme, { italic: true, fontSize: STATS_FONT_SIZE }),
                ml: index > 0 ? 0.5 : 0,
              }}
            >
              {part}
            </Typography>
          )
        }
        if (part.startsWith('-')) {
          return (
            <Typography
              key={`remove-${part}`}
              component="span"
              sx={{
                ...diffStatsRemovedSx(theme, { italic: true, fontSize: STATS_FONT_SIZE }),
                ml: index > 0 ? 0.5 : 0,
              }}
            >
              {part}
            </Typography>
          )
        }
        return (
          <Typography
            key={`text-${part}`}
            component="span"
            sx={{ ...defaultStatSx, ml: index > 0 ? 0.5 : 0 }}
          >
            {part}
          </Typography>
        )
      })}
    </Box>
  )
}

const STATS_FONT_SIZE = '0.75rem'

const statsContainerSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
}

const defaultStatSx: SxProps<Theme> = {
  fontSize: STATS_FONT_SIZE,
  color: 'text.secondary',
  fontStyle: 'italic',
}
